import script from "./header.vue?vue&type=script&lang=ts&setup=true"
export * from "./header.vue?vue&type=script&lang=ts&setup=true"

import "./header.vue?vue&type=style&index=0&id=0d084f2e&lang=less"
import "./header.vue?vue&type=style&index=1&id=0d084f2e&scoped=true&lang=less"

import exportComponent from "/workspace/hzjt-cms-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d084f2e"]])

export default __exports__